import { Avatar } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { UserProfile } from "@/types/user";

interface ProfileHeaderProps {
  profile: UserProfile;
  isEditing: boolean;
  onSave: () => void;
  onEdit: () => void;
}

export function ProfileHeader({ profile, isEditing, onSave, onEdit }: ProfileHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex items-center gap-4">
        <Avatar className="h-20 w-20">
          <div className="bg-blue-600 w-full h-full flex items-center justify-center text-white text-2xl">
            {profile.email?.charAt(0).toUpperCase()}
          </div>
        </Avatar>
        <div>
          <h1 className="text-2xl font-bold">{profile.name || profile.email}</h1>
          <p className="text-gray-600">{profile.role || 'Profissional'}</p>
        </div>
      </div>
      <div>
        {isEditing ? (
          <Button onClick={onSave}>Salvar Alterações</Button>
        ) : (
          <Button variant="outline" onClick={onEdit}>Editar Perfil</Button>
        )}
      </div>
    </div>
  );
}